/* eslint-disable react/no-unescaped-entities */
import { ArrowRight } from "lucide-react";
import { SIGNUP_URL } from "@/components/landing/constants";
import { useWaitlistForm } from "@/hooks/useWaitlistForm";

export default function FinalCTA() {
  const { email, setEmail, loading, onSubmit } = useWaitlistForm(
    "final-cta",
    "You're in. We'll be in touch the moment iOS + Android drop."
  );

  return (
    <section data-testid="final-cta-section" className="relative py-28 md:py-36 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 bg-aurora opacity-90" />
      <div className="pointer-events-none absolute inset-0 bg-grain" />
      <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center">
        <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.02]">
          <span className="text-gradient-hero">Your goal is personal.</span>
          <br />
          Start the intelligence today.
        </h2>
        <p className="mt-6 text-white/70 text-base sm:text-lg max-w-2xl mx-auto font-light">
          7 days free. Whatever you're working on, see what the smartest health AI says about it.
        </p>

        <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={SIGNUP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-primary"
            className="pill inline-flex items-center justify-center gap-2 bg-white text-black px-8 py-4 font-semibold text-base hover:bg-white/90 shadow-[0_8px_32px_rgba(124,92,252,0.35)]"
          >
            Start 7 days free
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
        <p className="mt-4 text-xs text-white/45">
          No credit card · Cancel anytime ·{" "}
          <span className="text-brand-accent font-semibold">
            ★ Google signup = 7 days Genius free
          </span>
        </p>

        <form
          onSubmit={onSubmit}
          data-testid="final-cta-waitlist-form"
          className="mt-14 glass-strong rounded-2xl p-2 max-w-xl mx-auto flex flex-col sm:flex-row gap-2"
        >
          <input
            type="email"
            required
            placeholder="Or join the iOS / Android waitlist"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="final-cta-waitlist-email"
            className="flex-1 bg-transparent px-4 py-3 text-sm text-white placeholder:text-white/40 focus:outline-none"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="final-cta-waitlist-submit"
            className="pill bg-brand-accent text-white px-6 py-3 text-sm font-semibold hover:bg-brand-accent/90 disabled:opacity-60"
          >
            {loading ? "Joining…" : "Join waitlist"}
          </button>
        </form>
      </div>
    </section>
  );
}
